import React from 'react';
import {
	ReactHookFormTextField,
	type ReactHookFormTextFieldProps,
} from '@netx/core-components/Form/TextField';
import type {ICustomFormItem, CustomFormFormValues} from '../../types';
import {
	getCustomFormItemTranslatedLabel,
	getCustomFormBaseFieldName,
} from '../../utils';

export interface ReactHookFormCustomFormItemTextProps<
	TValues extends CustomFormFormValues = CustomFormFormValues,
> extends Omit<
		ReactHookFormTextFieldProps<TValues>,
		'multiline' | 'name' | 'label' | 'required'
	> {
	item: ICustomFormItem;
}

export const ReactHookFormCustomFormItemTextPrimitive = <
	TValues extends CustomFormFormValues = CustomFormFormValues,
>({
	item,
	...props
}: ReactHookFormCustomFormItemTextProps<TValues>) => {
	const {label, type, required} = item;

	return (
		<ReactHookFormTextField
			data-testid="custom-form-item-text"
			fullWidth
			{...props}
			label={getCustomFormItemTranslatedLabel(label)}
			multiline={type === 'textarea'}
			name={getCustomFormBaseFieldName(item)}
			required={required}
		/>
	);
};

export const ReactHookFormCustomFormItemText =
	ReactHookFormCustomFormItemTextPrimitive;

export default ReactHookFormCustomFormItemText;
